export default __webpack_public_path__ + "static/media/github.ef0d89ba.svg";